import {Card, makeStyles} from "@fluentui/react-components";
import React, {useEffect} from "react";
import {teamsGroupStepAtom, errorAtom, graphClientAtom, teamsUserCredentialAtom} from "../../../store.ts";
import {useAtomValue, useSetAtom} from "jotai";
import {useGraphClient} from "../../../hooks";
import {SelectTeamsStep} from "./SelectTeamsStep.tsx";
import {SelectParticipantsStep} from "./SelectParticipantsStep.tsx";

const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px',
    }
});

export const AddAudienceTeamsView: React.FC = () => {
    const styles = useStyles();

    const currentStep = useAtomValue(teamsGroupStepAtom)
    const setError = useSetAtom(errorAtom);
    const teamsUserCredential = useAtomValue(teamsUserCredentialAtom);
    const setGraphClient = useSetAtom(graphClientAtom)

    const {
        getGraphClient,
        error: graphError,
        needsConsent,
        requestConsent
    } = useGraphClient(
        teamsUserCredential,
        ["User.ReadBasic.All", "Team.ReadBasic.All", "TeamMember.Read.All"]
    );

    useEffect(() => {
        getGraphClient().then(client => {
            setGraphClient(client);
            setError(null)
        })
    }, []);

    useEffect(() => {
        setError(graphError)
    }, [graphError]);

    useEffect(() => {
        if (needsConsent) {
            requestConsent().then(success => {
                if (success) {
                    getGraphClient().then(client => {
                        setGraphClient(client);
                        setError(null)
                    })
                }
            })
        }
    }, [needsConsent]);



    return (
        <Card style={{ margin: '0 16px' }}>
            <div className={styles.container}>
                {currentStep === 'selectTeams' ? <SelectTeamsStep/> : <SelectParticipantsStep/>}
            </div>
        </Card>
    );
}
